import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../../shared/http-utils';

@Injectable()
export class AiApiHeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only add headers to requests aimed at AI API
    if (req.url.startsWith(environment.URL_AI)) {
      // When sending FormData, we must let the browser set the Content-Type
      // so it can correctly add the multipart boundary.
      const headers = HttpUtils.createBearerHeaders();
      if (req.body instanceof FormData) {
        headers.delete('Content-Type');
      }
      const apiReq = req.clone({ headers });
      return next.handle(apiReq);
    }

    return next.handle(req);
  }
}
